// extracted by mini-css-extract-plugin
export default {"inputText":"Input_inputText__0vYu2","modalInput":"Input_modalInput__rqgPd","passwInput":"Input_passwInput__ZvoFS"};